import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../hooks/redux";
import { CartItemImageProps } from "../interfaces";
import Spinner from "../spinner/Spinner";
import "./cartItemImage.scss";

const CartItemImage: React.FC<CartItemImageProps> = ({ itemId, defaultSrc, alt, onClick }) => {
  const status = useAppSelector((state) => state.shoppingCart.imgStatus);
  const isLoading = useAppSelector(
    (state) => state.shoppingCart.loadingMaterialById[itemId]
  );
    
  const materialData = useAppSelector((state) =>
    state.shoppingCart.materialPriceAndImgForCart.find(
      (entry) => entry.itemId === itemId
    )
  );
  const materialImages = React.useMemo(() => materialData?.materialImages || [], [materialData]);
  const [imageUrl, setImageUrl] = useState(defaultSrc);
  
  useEffect(() => {
    if (materialImages.length > 0) {
      setImageUrl(materialImages[0].image.publicUrl);
    } else {
      setImageUrl(defaultSrc);
    }
  }, [materialImages, defaultSrc, itemId]);
  
    const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
      e.currentTarget.onerror = null;
      e.currentTarget.src = defaultSrc;
    };
  
    const isError = status === "failed";
    return (
      <div
        className="cart-item-image-container"
        role="button"
        tabIndex={0}
        aria-label={`View ${alt}`}
        onClick={onClick}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick?.();
          }
        }}
      >
        {isLoading && (
          <div className="spinner-container-cart-item ">
            <Spinner />
          </div>
        )}
  
        {!isLoading && isError && (
          <div className="fallback-container">
            <img className="fallback-image" src={defaultSrc} alt="Placeholder" />
          </div>
        )}
  
        {!isError && (
          <img
            className={`cart-item-image ${isLoading ? "hidden" : "fade-in"}`}
            src={imageUrl}
            alt={alt}
            onError={handleImageError}
          />
        )}
      </div>
    );
  };
    
  export default CartItemImage;
